var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5713 2.5C8.77129 2.5 2.57129 8.7 2.57129 16.5C2.57129 24.3 8.77129 30.5 16.5713 30.5C24.3713 30.5 30.5713 24.3 30.5713 16.5C30.5713 8.7 24.3713 2.5 16.5713 2.5ZM16.5713 28.5C9.97129 28.5 4.57129 23.1 4.57129 16.5C4.57129 9.9 9.97129 4.5 16.5713 4.5C23.1713 4.5 28.5713 9.9 28.5713 16.5C28.5713 23.1 23.1713 28.5 16.5713 28.5Z",
    fill: "#A40000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9713 23.5L16.5713 18.1L11.1713 23.5L9.57129 21.9L14.9713 16.5L9.57129 11.1L11.1713 9.5L16.5713 14.9L21.9713 9.5L23.5713 11.1L18.1713 16.5L23.5713 21.9L21.9713 23.5Z",
    fill: "#A40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/close-outline.c4f1e58c35f714cbef0eb01cfef8a3d0.svg";
export { ForwardRef as ReactComponent };